import { ModelRow } from "@mcleod/core";
import { Button, ClickEvent, Table, TableSelectionEvent } from "@mcleod/components";
import { AutogenLayoutTractorListToolPanel } from "./autogen/AutogenLayoutTractorListToolPanel";
import { Seating, SeatingEquipmentType } from "../asset/Seating";
import { AutogenLayoutTractorList } from "./autogen/AutogenLayoutTractorList";

export enum Tools {
    SEAT_TRACTOR
}

export class TractorListToolPanel extends AutogenLayoutTractorListToolPanel {
    private table: Table;
    private tableSelectedPromise: Promise<void>;

    override onLoad() {
        this.addMountListener(() => this.initialize(this.owner));
    }

    private getAllVisibleButtons(): Button[] {
        return this.panelButtons?.findComponentsByType(Button)?.filter(button => button.visible);
    }

    initialize(layout: AutogenLayoutTractorList) {
        this.table = layout?.findComponentById("tableTractors") as Table;
        this.table?.addSelectionListener((event: TableSelectionEvent) => {
        this.tableSelectedPromise = this.tableOnSelect(event);
        });
    }

    async tableOnSelect(event: TableSelectionEvent) {
        const modelRow = event.newRow?.data;
        await this.syncToolPanel(modelRow);
    }

    public async syncToolPanel(modelRow: ModelRow) {
        this.getAllVisibleButtons().forEach(button => {
            button.disabledTooltip = null;
            button.enabled = modelRow != null;
            if (button.enabled) {
                this.syncButtonState(button, modelRow);
            }
        });
    }

    private syncButtonState(button: Button, modelRow: ModelRow) {
        if (button === this.buttonSeatTractor) {
            this.buttonSeatTractorEnabled(modelRow);
        }
    }

    showButtons(...tools: Tools[]) {
        for (const tool of tools) {
            switch (tool) {
                case Tools.SEAT_TRACTOR:
                    this.buttonSeatTractor.visible = true;
                    break;
            }
        }
    }

    private buttonSeatTractorEnabled(modelRow: ModelRow): boolean {
        if (this.buttonSeatTractor.visible === false || modelRow == null) {
            this.buttonSeatTractor.enabled = false;
            return false;
        }
        if (modelRow.get("service_status") === "I") {
            this.buttonSeatTractor.enabled = false;
            this.buttonSeatTractor.disabledTooltip = "Tractor's Service Status must be Active to locate.";
            return false;
        }
        if (modelRow.get("movement.status") === "P") {
            this.buttonSeatTractor.enabled = false;
            this.buttonSeatTractor.disabledTooltip = "Cannot seat Tractor for In-Progress movements";
            return false;
        }
        this.buttonSeatTractor.enabled = true;
        return true;
    }

    buttonSeatTractorOnClick(event: ClickEvent) {
        const modelRow: ModelRow = this.table?.selectedRow?.data;
        if (modelRow == null)
            return;
        const button = event.target as Button;
        button.busy = true;
        Seating.showSlideout({
            equipmentId: modelRow.get("id"),
            equipmentType: SeatingEquipmentType.TRACTOR,
            forceMasterfileUpdate: true,
            doAfterSave: () => {
                this.table?.selectedRow?.updateDataFromComponents();
                this.table.dataSource.search(this.table.dataSource.lastSearch);
            }
        });
        button.busy = false;
    }
}
